import { SimCardFragment } from "@phonero/common-ux"
import { PuxIcon, PuxText, useTranslation } from "@phonero/pux-react"
import css from "./SimCardSlides.module.scss"
import { info } from "@phonero/pux-icons/icons"
import React from "react"

export const SimReadyForActivationText = ({
  card,
  style,
}: {
  card: SimCardFragment
  style?: {}
}) => {
  const { t } = useTranslation()

  return (
    <div className={css["ready-for-activation-text"]} style={style}>
      <table style={{ width: "100%" }}>
        <tbody>
          {card.embeddedSim && (
            <tr className={css["e-sim"]}>
              <td>
                <PuxIcon icon={info} size="small"></PuxIcon>
              </td>
              <td className={css["left-aligned-column"]}>
                {card.embeddedSim && (
                  <PuxText>{t("EmbeddedSim.ReadyForActivationText")}</PuxText>
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
